import RefreshIcon from '@mui/icons-material/Refresh'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'ui-components'
import BrandImage from './BrandImage'

interface ErrorProps {
  imageBaseName: string
  title: string
  text: string
  buttonText?: string
}

const Error = ({
  imageBaseName,
  title,
  text,
  buttonText,
}: ErrorProps): JSX.Element => {
  const { uuid } = useParams<string>()
  const navigate = useNavigate()

  const reloadHandler = (e: React.SyntheticEvent) => {
    e.preventDefault()
    navigate(`/${uuid}`)
  }

  return (
    <Stack
      sx={{
        py: 2,
        px: 3,
        marginX: 'auto',
        maxWidth: 'lg',
        alignItems: 'center',
        textAlign: 'center',
        marginTop: 3,
        '& > img': {
          marginBottom: 3,
        },
      }}
      gap={1}
    >
      <BrandImage imageBaseName={imageBaseName} altText={title} />
      <Typography variant="h3" component="h1">
        {title}
      </Typography>
      <Typography variant="body2" component="p">
        {text}
      </Typography>
      {uuid && buttonText && (
        <Button
          color={'primaryLight'}
          startIcon={<RefreshIcon />}
          data-testid={'error-page.reload-page'}
          onClick={reloadHandler}
          sx={{ mt: 5 }}
        >
          {buttonText}
        </Button>
      )}
    </Stack>
  )
}

export default Error
